import type { ReactNode } from 'react'

export type PillTone = 'ink' | 'flame' | 'mustard' | 'leaf'

// Color encodes the semantic tone (cf. "Terracotta Rule" as implemented in Kraft):
// leaf = success, mustard = warning/pending, flame = action required, ink = neutral.
const TONE: Record<PillTone, string> = {
  ink: 'bg-ink-tint text-ink',
  flame: 'bg-flame-tint text-flame-deep',
  mustard: 'bg-mustard-tint text-mustard-deep',
  leaf: 'bg-leaf-tint text-leaf-deep',
}

export function Pill({ tone = 'ink', className = '', children }: { tone?: PillTone; className?: string; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center justify-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-extrabold ${TONE[tone]} ${className}`}>
      {children}
    </span>
  )
}
